export default "__VITE_ASSET__BPLp3sZ9__"